import React, { useState, useEffect } from 'react'
import { Button, Select, Spin, Avatar, Space, Popconfirm } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'
import axios from 'axios'
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc'
import { arrayMoveImmutable } from 'array-move'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

const limitText = (text, limit = 50) => (text.length > limit ? text.slice(0, limit) + '...' : text)

function ViewProducts() {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [organizations, setOrganizations] = useState([])
  const [products, setProducts] = useState([])
  const [selectedOrg, setSelectedOrg] = useState('')
  const auth = useSelector((state) => state.auth)

  const DragHandle = sortableHandle(() => <span style={{ cursor: 'grab', marginRight: 8 }}>☰</span>)

  const SortableItem = sortableElement(({ item }) => {
    return (
      <li
        style={{
          listStyle: 'none',
          padding: '10px 14px',
          margin: '8px 0',
          border: '1px solid #ddd',
          borderRadius: 6,
          background: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <DragHandle />

          <Avatar src={(item.attachments && item.attachments[0]?.mediaLink) || ``} size={40} />

          <div>
            <div style={{ fontWeight: 600 }}>{item.name}</div>
            <div style={{ fontSize: 12 }}>{limitText(item.description, 100)}</div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
          <div>{item.requiredPoints}</div>

          <div>{item.disabled ? 'TRUE' : 'FALSE'}</div>

          <p style={{ fontSize: 9, margin: 0 }}>{moment(item.createdAt).format('DD MMMM YY h:mm a')}</p>

          <Space size="middle">
            <a href={`/manageStore/addProducts?id=${item._id}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1677ff', cursor: 'pointer' }}>
              Edit
            </a>

            {item.disabled ? (
              <Button type="ghost" style={{ color: '#1677ff', cursor: 'pointer' }} onClick={() => onDisable(`${item._id}`, false)}>
                Publish
              </Button>
            ) : (
              <Popconfirm
                title="Are you sure to Disable this?"
                description="This will no longer visible to users."
                onConfirm={() => onDisable(`${item._id}`, true)}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <Button type="ghost" style={{ color: 'red', cursor: 'pointer' }}>
                  Disable
                </Button>
              </Popconfirm>
            )}
          </Space>
        </div>
      </li>
    )
  })

  const SortableList = sortableContainer(({ items }) => {
    return (
      <ul style={{ padding: 0, marginTop: 20 }}>
        {items.map((item, index) => (
          <SortableItem key={item._id} index={index} item={item} />
        ))}
      </ul>
    )
  })

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setProducts((prev) => {
      const reordered = arrayMoveImmutable(prev, oldIndex, newIndex)
      updateOrder(reordered) // Save to backend
      return reordered
    })
  }

  const updateOrder = async (array) => {
    try {
      setLoading(true)
      await axiosInstance.put(`/api/v1/storeFront/setOrderedProducts`, {
        ids: array.map((elem) => ({ _id: elem._id })),
      })
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const onDisable = async (id, disabled) => {
    const fmData = new FormData()

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        authorization: `Bearer ${auth.token}`,
      },
    }
    fmData.append('disabled', disabled)
    fmData.append('removedAttachmentNames', JSON.stringify([])) // Its required at backend

    const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/storeFront/editProduct?docId=${id}`, fmData, config)

    console.log(res.data)

    alert('Success')
    window.location.reload()
  }

  const handleChange = (value) => {
    setSelectedOrg(value)
    getProducts(value)
  }

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      if (response?.data?.user?.organizations?.length > 0) {
        const org = response.data.user.organizations
        // store to render at JSX
        org.forEach((element) => {
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }
      setLoading(false)
    } catch (e) {
      console.log(e)
    }
  }

  const getProducts = async (org) => {
    try {
      setLoading(true)

      const query = org ? `?orgId=${org}` : ''
      const response = await axiosInstance.get(`/api/v1/storeFront/getProducts${query}`)

      setProducts(response.data.products)

      setLoading(false)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getMyInfo()
    getProducts()
  }, [])

  return (
    <Layout>
      <Button onClick={() => navigate(-1)}>Back</Button>
      <h2>View Products</h2>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      )}

      {organizations.length > 0 && (
        <div style={{ marginBottom: 10 }}>
          <p>Choose organization</p>
          <Select
            placeholder="Please select club or business"
            style={{
              width: 250,
              marginRight: 10,
            }}
            onChange={handleChange}
            options={organizations}
          />
        </div>
      )}

      <p>You can drag products to reorder them. Changes will save automatically.</p>

      <SortableList items={products} onSortEnd={onSortEnd} useDragHandle />
    </Layout>
  )
}

export default ViewProducts
